/*quickstart*/
/*guide*/
/*create-a-monorepo*/
/*create-a-directory-for-the-app*/
/*add-the-storybook-application*/
/*add-your-ui-kit-to-storybook*/
/*set-up-a-story-for-your-button-component*/
/*align-scripts-to-your-tasks*/
/*add-storybook-build-outputs-to-gitignore*/
/*verify-your-configuration*/
/*more-tips*/
/*co-locating-stories*/
/*re-configure-storybook-sources*/
/*move-story-files-to-the-ui-package*/
/*configure-caching*/
/*rename-the-build-script*/
/*verify-your-configuration-1*/
/*adding-css*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Storybook",
  "description": "学习如何在 Turborepo 中使用 Storybook。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Storybook 是一种在隔离环境中构建 UI 组件的常用方法。通过将 Storybook 放入 Turborepo，你可以轻松地与应用一起开发设计系统。"
  }, {
    "heading": "",
    "content": "¥Storybook is a popular way to build UI components in an isolated environment. By putting Storybook into your Turborepo, you can easily develop your design system right alongside your applications."
  }, {
    "heading": "快速入门-quickstart",
    "content": "¥Quickstart"
  }, {
    "heading": "快速入门-quickstart",
    "content": "如果你希望使用模板，本指南将介绍如何在 Vercel 上构建 这个 Storybook/Turborepo 模板。"
  }, {
    "heading": "快速入门-quickstart",
    "content": "¥If you'd rather use a template, this guide is walking through how to build this Storybook/Turborepo template on Vercel."
  }, {
    "heading": "指南-guide",
    "content": "¥Guide"
  }, {
    "heading": "创建-monorepo-create-a-monorepo",
    "content": "¥Create a monorepo"
  }, {
    "heading": "创建-monorepo-create-a-monorepo",
    "content": "如果你没有现有项目，请使用 create-turbo 创建一个新的 monorepo："
  }, {
    "heading": "创建-monorepo-create-a-monorepo",
    "content": "¥If you don't have an existing project, use create-turbo to create a new monorepo:"
  }, {
    "heading": "为应用创建目录-create-a-directory-for-the-app",
    "content": "¥Create a directory for the app"
  }, {
    "heading": "为应用创建目录-create-a-directory-for-the-app",
    "content": "你需要一个用于 Storybook 应用的目录："
  }, {
    "heading": "为应用创建目录-create-a-directory-for-the-app",
    "content": "¥You'll need a directory for the Storybook application:"
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "¥Add the Storybook application"
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "在 apps/storybook 目录中，初始化一个新的 Storybook 应用："
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "¥In the apps/storybook directory, initialize a new Storybook application:"
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "按照提示创建应用。在本指南的其余部分，我们将假设使用 React 和 TypeScript。"
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "¥Follow the prompts to create an application. For the rest of this guide, we'll assume React and TypeScript."
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "完成 Storybook 的入门后，你就可以使用 卸载 onboarding 插件 了。"
  }, {
    "heading": "添加-storybook-应用-add-the-storybook-application",
    "content": "¥After going through Storybook's onboarding, you can uninstall the onboarding\naddon."
  }, {
    "heading": "将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
    "content": "¥Add your UI kit to Storybook"
  }, {
    "heading": "将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
    "content": "现在，将你的 UI 包安装到 Storybook 中。"
  }, {
    "heading": "将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
    "content": "¥Now, install your UI package into Storybook."
  }, {
    "heading": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "¥Set up a story for your Button component"
  }, {
    "heading": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "删除在 src/stories 目录中由 Storybook 脚手架工具创建的故事和组件。你将创建自己的 Dockerfile。"
  }, {
    "heading": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "¥Delete the stories and components found in src/stories that were created by the Storybook scaffolding tool. You will be making your own."
  }, {
    "heading": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "例如，这是 @repo/ui/button 中 Button 组件的故事。"
  }, {
    "heading": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "¥As an example, here is a story for the Button component from @repo/ui/button."
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "¥Align scripts to your tasks"
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "最后，将新的 Storybook 应用集成到你的 Turborepo 中："
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "¥Last, integrate the new Storybook application into your Turborepo:"
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "这些脚本现在将与你的 turbo.json 中的 turbo dev 和 turbo build 任务一起运行。"
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "¥These scripts will now run with the turbo dev and turbo build tasks in your turbo.json."
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "为确保在运行 build 时文件输出被缓存，请将 storybook-static 添加到 turbo.json 构建任务的输出中："
  }, {
    "heading": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "¥To ensure file outputs are cached when you run build, add storybook-static to the outputs of your turbo.json build task:"
  }, {
    "heading": "将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
    "content": "¥Add Storybook build outputs to .gitignore"
  }, {
    "heading": "将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
    "content": "确保 Storybook 的构建输出未提交到源代码管理"
  }, {
    "heading": "将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
    "content": "¥Ensure that the build outputs for Storybook are not committed to source control"
  }, {
    "heading": "验证配置-verify-your-configuration",
    "content": "¥Verify your configuration"
  }, {
    "heading": "验证配置-verify-your-configuration",
    "content": "运行 turbo build 以构建 Storybook 应用以及其他应用。"
  }, {
    "heading": "验证配置-verify-your-configuration",
    "content": "¥Run turbo build to build the Storybook application alongside the rest of your applications."
  }, {
    "heading": "验证配置-verify-your-configuration",
    "content": "你还可以再次运行 turbo build 来查看构建的缓存命中情况。"
  }, {
    "heading": "验证配置-verify-your-configuration",
    "content": "¥You can also run turbo build again to see cache hits for your builds."
  }, {
    "heading": "更多提示-more-tips",
    "content": "¥More tips"
  }, {
    "heading": "共置故事-co-locating-stories",
    "content": "¥Co-locating stories"
  }, {
    "heading": "共置故事-co-locating-stories",
    "content": "如果你希望将故事与其源代码放在一起（而不是将它们放在 Storybook 应用中），则需要进行一些额外的配置。"
  }, {
    "heading": "共置故事-co-locating-stories",
    "content": "¥If you'd prefer to co-locate your stories to their source code (rather than having them in the Storybook application), you'll need some extra configuration."
  }, {
    "heading": "重新配置-storybook-源-re-configure-storybook-sources",
    "content": "¥Re-configure Storybook sources"
  }, {
    "heading": "重新配置-storybook-源-re-configure-storybook-sources",
    "content": "在 .storybook/main.ts 中，将 config 中的 stories 路径更改为你想要捕获的目录。例如，如果你想在 UI 包中编写故事："
  }, {
    "heading": "重新配置-storybook-源-re-configure-storybook-sources",
    "content": "¥In .storybook/main.ts, change the stories paths in config to the directories you'd like to capture. For instance, if you'd like to write stories in the UI package:"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "¥Move story files to the UI package"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "按照 上一指南 的原则，将 ./apps/storybook/src/stories/Button.stories.tsx 文件移动到 ./packages/ui/src/Button.stories.tsx。"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "¥Following along with the guide above, move the ./apps/storybook/src/stories/Button.stories.tsx file to ./packages/ui/src/Button.stories.tsx."
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "更新组件导入，使其引用现在位于同一位置的模块。例如，在故事的导入中："
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "¥Update components imports so that they reference the now co-located modules. For instance, in the story's imports:"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "你可能还需要根据你的更改和使用情况更新 绝对值导入。"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "¥You may also need to update absolute\nimports\naccording to your changes and usage."
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "你还需要安装编写故事所需的所有 Storybook 包。例如，从上面移动故事需要你将 @storybook/react 安装到你的 @repo/ui 包中。"
  }, {
    "heading": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "¥You'll also need to install any Storybook packages required for writing stories. For example, moving the story from above would require that you install @storybook/react into your @repo/ui package."
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "¥Configure caching"
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "由于故事现在位于 UI 包中，因此对这些故事的更改可能会导致任何依赖于 UI 包的构建发生缓存未命中。但是，更改故事并不意味着你的生产应用应该丢失缓存。"
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "¥Because stories are now in the UI package, changes to those stories can cause cache misses for any builds that depend on your UI package. However, changing a story doesn't mean your production applications should miss cache."
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "为防止这种情况，请在根 turbo.json 中将故事从 build 任务的输入中排除。你还需要创建一个 build:storybook 任务，稍后你将需要它："
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "¥To prevent this, exclude stories from the inputs to your build task in your root turbo.json. You'll also need to create a build:storybook task, which you'll need in a moment:"
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "此外，在 storybook 应用中创建一个 软件包配置，以便在构建 Storybook 应用时考虑故事，具体来说："
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "¥Additionally, create a Package Configuration in the storybook application so stories are accounted for in building the Storybook application, specifically:"
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "如果你正在使用 编译包模式，则可能还需要将 ^build 添加到你的 dependsOn 中。"
  }, {
    "heading": "配置缓存-configure-caching",
    "content": "¥If you are using the Compiled Package\npattern, you may\nalso need to add ^build to your dependsOn."
  }, {
    "heading": "重命名构建脚本-rename-the-build-script",
    "content": "¥Rename the build script"
  }, {
    "heading": "重命名构建脚本-rename-the-build-script",
    "content": "最后，确保你用于构建 Storybook 的脚本使用我们刚刚编写的配置，方法是将其重命名为任务名称："
  }, {
    "heading": "重命名构建脚本-rename-the-build-script",
    "content": "¥Last, make sure your script to build Storybook uses the configuration we just wrote by renaming it to the name of the task:"
  }, {
    "heading": "重命名构建脚本-rename-the-build-script",
    "content": "曾经是 \"build\" 的脚本现在变为 \"build:storybook\"，以确保故事包含在哈希表中以便缓存。"
  }, {
    "heading": "重命名构建脚本-rename-the-build-script",
    "content": "¥The script that was once \"build\" is now \"build:storybook\" to ensure the stories are included in hashes for caching."
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥Verify your configuration"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "为确保你的设置正确："
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥To ensure your setup is correct:"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "运行 turbo build:storybook build。你应该看到缓存未命中。"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥Run turbo build:storybook build. You should see cache misses."
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "再次运行 turbo build:storybook build。你应该看到所有缓存命中。"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥Run turbo build:storybook build again. You should see all cache hits."
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "对你的 @repo/ui 软件包中的故事进行代码更改。"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥Make a code change to a story in your @repo/ui package."
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "再次运行 turbo build:storybook build。你应该只会看到 Storybook 应用的缓存未命中。所有其他变量都应该命中缓存。"
  }, {
    "heading": "验证配置-verify-your-configuration-1",
    "content": "¥Run turbo build:storybook build again. You should only see a cache miss for the Storybook application. All others should hit cache."
  }, {
    "heading": "添加-css-adding-css",
    "content": "¥Adding CSS"
  }, {
    "heading": "添加-css-adding-css",
    "content": "如果你的 UI 包导出了其自身的 CSS，则需要将其添加到 Storybook 应用的渲染中，类似于将其添加到应用中的方式。Storybook 文档 建议你将其添加到 .storybook/preview.ts 文件中。"
  }, {
    "heading": "添加-css-adding-css",
    "content": "¥If your UI package exports its own CSS, you'll need to add it to the renders in the Storybook app, similar to how you would add it to your applications. The Storybook documentation recommends you add it to the .storybook/preview.ts file."
  }],
  "headings": [{
    "id": "快速入门-quickstart",
    "content": "快速入门 /*quickstart*/"
  }, {
    "id": "指南-guide",
    "content": "指南 /*guide*/"
  }, {
    "id": "创建-monorepo-create-a-monorepo",
    "content": "创建 monorepo /*create-a-monorepo*/"
  }, {
    "id": "为应用创建目录-create-a-directory-for-the-app",
    "content": "为应用创建目录 /*create-a-directory-for-the-app*/"
  }, {
    "id": "添加-storybook-应用-add-the-storybook-application",
    "content": "添加 Storybook 应用 /*add-the-storybook-application*/"
  }, {
    "id": "将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
    "content": "将你的 UI 工具包添加到 Storybook /*add-your-ui-kit-to-storybook*/"
  }, {
    "id": "为-button-组件设置故事-set-up-a-story-for-your-button-component",
    "content": "为 Button 组件设置故事 /*set-up-a-story-for-your-button-component*/"
  }, {
    "id": "将脚本与你的任务-align-scripts-to-your-tasks",
    "content": "将脚本与你的任务 /*align-scripts-to-your-tasks*/"
  }, {
    "id": "将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
    "content": "将 Storybook 构建输出添加到 .gitignore /*add-storybook-build-outputs-to-gitignore*/"
  }, {
    "id": "验证配置-verify-your-configuration",
    "content": "验证配置 /*verify-your-configuration*/"
  }, {
    "id": "更多提示-more-tips",
    "content": "更多提示 /*more-tips*/"
  }, {
    "id": "共置故事-co-locating-stories",
    "content": "共置故事 /*co-locating-stories*/"
  }, {
    "id": "重新配置-storybook-源-re-configure-storybook-sources",
    "content": "重新配置 Storybook 源 /*re-configure-storybook-sources*/"
  }, {
    "id": "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
    "content": "将故事文件移动到 UI 包 /*move-story-files-to-the-ui-package*/"
  }, {
    "id": "配置缓存-configure-caching",
    "content": "配置缓存 /*configure-caching*/"
  }, {
    "id": "重命名构建脚本-rename-the-build-script",
    "content": "重命名构建脚本 /*rename-the-build-script*/"
  }, {
    "id": "验证配置-verify-your-configuration-1",
    "content": "验证配置 /*verify-your-configuration-1*/"
  }, {
    "id": "添加-css-adding-css",
    "content": "添加 CSS /*adding-css*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
export const toc = [{
  depth: 2,
  url: "#快速入门-quickstart",
  title: _jsx(_Fragment, {
    children: "快速入门 "
  })
}, {
  depth: 2,
  url: "#指南-guide",
  title: _jsx(_Fragment, {
    children: "指南 "
  })
}, {
  depth: 3,
  url: "#创建-monorepo-create-a-monorepo",
  title: _jsx(_Fragment, {
    children: "创建 monorepo "
  })
}, {
  depth: 3,
  url: "#为应用创建目录-create-a-directory-for-the-app",
  title: _jsx(_Fragment, {
    children: "为应用创建目录 "
  })
}, {
  depth: 3,
  url: "#添加-storybook-应用-add-the-storybook-application",
  title: _jsx(_Fragment, {
    children: "添加 Storybook 应用 "
  })
}, {
  depth: 3,
  url: "#将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
  title: _jsx(_Fragment, {
    children: "将你的 UI 工具包添加到 Storybook "
  })
}, {
  depth: 3,
  url: "#为-button-组件设置故事-set-up-a-story-for-your-button-component",
  title: _jsx(_Fragment, {
    children: "为 Button 组件设置故事 "
  })
}, {
  depth: 3,
  url: "#将脚本与你的任务-align-scripts-to-your-tasks",
  title: _jsx(_Fragment, {
    children: "将脚本与你的任务 "
  })
}, {
  depth: 3,
  url: "#将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
  title: _jsxs(_Fragment, {
    children: ["将 Storybook 构建输出添加到 ", _jsx("code", {
      children: ".gitignore"
    }), " "]
  })
}, {
  depth: 3,
  url: "#验证配置-verify-your-configuration",
  title: _jsx(_Fragment, {
    children: "验证配置 "
  })
}, {
  depth: 2,
  url: "#更多提示-more-tips",
  title: _jsx(_Fragment, {
    children: "更多提示 "
  })
}, {
  depth: 3,
  url: "#共置故事-co-locating-stories",
  title: _jsx(_Fragment, {
    children: "共置故事 "
  })
}, {
  depth: 4,
  url: "#重新配置-storybook-源-re-configure-storybook-sources",
  title: _jsx(_Fragment, {
    children: "重新配置 Storybook 源 "
  })
}, {
  depth: 4,
  url: "#将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
  title: _jsx(_Fragment, {
    children: "将故事文件移动到 UI 包 "
  })
}, {
  depth: 4,
  url: "#配置缓存-configure-caching",
  title: _jsx(_Fragment, {
    children: "配置缓存 "
  })
}, {
  depth: 4,
  url: "#重命名构建脚本-rename-the-build-script",
  title: _jsx(_Fragment, {
    children: "重命名构建脚本 "
  })
}, {
  depth: 4,
  url: "#验证配置-verify-your-configuration-1",
  title: _jsx(_Fragment, {
    children: "验证配置 "
  })
}, {
  depth: 3,
  url: "#添加-css-adding-css",
  title: _jsx(_Fragment, {
    children: "添加 CSS "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://storybook.nodejs.cn/",
        children: "Storybook"
      }), " 是一种在隔离环境中构建 UI 组件的常用方法。通过将 Storybook 放入 Turborepo，你可以轻松地与应用一起开发设计系统。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://storybook.nodejs.cn/",
        children: "Storybook"
      }), " is a popular way to build UI components in an isolated environment. By putting Storybook into your Turborepo, you can easily develop your design system right alongside your applications."]
    }), "\n", _jsx(_components.h2, {
      id: "快速入门-quickstart",
      children: "快速入门 "
    }), "\n", _jsx(_components.p, {
      children: "¥Quickstart"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你希望使用模板，本指南将介绍如何在 Vercel 上构建 ", _jsx(_components.a, {
        href: "https://vercel.com/templates/react/turborepo-design-system",
        children: "这个 Storybook/Turborepo 模板"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you'd rather use a template, this guide is walking through how to build ", _jsx(_components.a, {
        href: "https://vercel.com/templates/react/turborepo-design-system",
        children: "this Storybook/Turborepo template"
      }), " on Vercel."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " design-system"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "指南-guide",
      children: "指南 "
    }), "\n", _jsx(_components.p, {
      children: "¥Guide"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "创建-monorepo-create-a-monorepo",
          children: "创建 monorepo "
        }), _jsx(_components.p, {
          children: "¥Create a monorepo"
        }), _jsxs(_components.p, {
          children: ["如果你没有现有项目，请使用 ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "create-turbo"
          }), " 创建一个新的 monorepo："]
        }), _jsxs(_components.p, {
          children: ["¥If you don't have an existing project, use ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "create-turbo"
          }), " to create a new monorepo:"]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bunx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "为应用创建目录-create-a-directory-for-the-app",
          children: "为应用创建目录 "
        }), _jsx(_components.p, {
          children: "¥Create a directory for the app"
        }), _jsx(_components.p, {
          children: "你需要一个用于 Storybook 应用的目录："
        }), _jsx(_components.p, {
          children: "¥You'll need a directory for the Storybook application:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "mkdir"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/storybook"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "cd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " apps/storybook"
                })]
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "添加-storybook-应用-add-the-storybook-application",
          children: "添加 Storybook 应用 "
        }), _jsx(_components.p, {
          children: "¥Add the Storybook application"
        }), _jsxs(_components.p, {
          children: ["在 ", _jsx(_components.code, {
            children: "apps/storybook"
          }), " 目录中，初始化一个新的 Storybook 应用："]
        }), _jsxs(_components.p, {
          children: ["¥In the ", _jsx(_components.code, {
            children: "apps/storybook"
          }), " directory, initialize a new Storybook application:"]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook@latest"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsx(_components.p, {
          children: "按照提示创建应用。在本指南的其余部分，我们将假设使用 React 和 TypeScript。"
        }), _jsx(_components.p, {
          children: "¥Follow the prompts to create an application. For the rest of this guide, we'll assume React and TypeScript."
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["完成 Storybook 的入门后，你就可以使用 ", _jsx(_components.a, {
              href: "https://github.com/storybookjs/addon-onboarding/blob/main/README.md",
              children: "卸载 onboarding 插件"
            }), " 了。"]
          }), _jsxs(_components.p, {
            children: ["¥After going through Storybook's onboarding, you can ", _jsx(_components.a, {
              href: "https://github.com/storybookjs/addon-onboarding/blob/main/README.md",
              children: "uninstall the onboarding\naddon"
            }), "."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "将你的-ui-工具包添加到-storybook-add-your-ui-kit-to-storybook",
          children: "将你的 UI 工具包添加到 Storybook "
        }), _jsx(_components.p, {
          children: "¥Add your UI kit to Storybook"
        }), _jsx(_components.p, {
          children: "现在，将你的 UI 包安装到 Storybook 中。"
        }), _jsx(_components.p, {
          children: "¥Now, install your UI package into Storybook."
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=storybook"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " storybook"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=storybook"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " apps/storybook"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: " &&"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: " bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "为-button-组件设置故事-set-up-a-story-for-your-button-component",
          children: "为 Button 组件设置故事 "
        }), _jsx(_components.p, {
          children: "¥Set up a story for your Button component"
        }), _jsxs(_components.p, {
          children: ["删除在 ", _jsx(_components.code, {
            children: "src/stories"
          }), " 目录中由 Storybook 脚手架工具创建的故事和组件。你将创建自己的 Dockerfile。"]
        }), _jsxs(_components.p, {
          children: ["¥Delete the stories and components found in ", _jsx(_components.code, {
            children: "src/stories"
          }), " that were created by the Storybook scaffolding tool. You will be making your own."]
        }), _jsxs(_components.p, {
          children: ["例如，这是 ", _jsx(_components.code, {
            children: "@repo/ui/button"
          }), " 中 ", _jsx(_components.code, {
            children: "Button"
          }), " 组件的故事。"]
        }), _jsxs(_components.p, {
          children: ["¥As an example, here is a story for the ", _jsx(_components.code, {
            children: "Button"
          }), " component from ", _jsx(_components.code, {
            children: "@repo/ui/button"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/src/stories/Button.stories.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " type"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { Meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " StoryObj } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '@storybook/react'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { Button } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '@repo/ui/button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  title"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'Example/Button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  component"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " Button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  tags"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "'autodocs'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "} "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "satisfies"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Meta"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "<"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "typeof"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " Button>;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " meta;"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "type"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Story"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " StoryObj"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "<"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "typeof"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " meta>;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " Primary"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Story"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  args"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    appName"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'Button'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    children"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'I am a primary button.'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "将脚本与你的任务-align-scripts-to-your-tasks",
          children: "将脚本与你的任务 "
        }), _jsx(_components.p, {
          children: "¥Align scripts to your tasks"
        }), _jsx(_components.p, {
          children: "最后，将新的 Storybook 应用集成到你的 Turborepo 中："
        }), _jsx(_components.p, {
          children: "¥Last, integrate the new Storybook application into your Turborepo:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "apps/storybook/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook dev -p 6006\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook build\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["这些脚本现在将与你的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "turbo dev"
          }), " 和 ", _jsx(_components.code, {
            children: "turbo build"
          }), " 任务一起运行。"]
        }), _jsxs(_components.p, {
          children: ["¥These scripts will now run with the ", _jsx(_components.code, {
            children: "turbo dev"
          }), " and ", _jsx(_components.code, {
            children: "turbo build"
          }), " tasks in your ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), _jsxs(_components.p, {
          children: ["为确保在运行 ", _jsx(_components.code, {
            children: "build"
          }), " 时文件输出被缓存，请将 ", _jsx(_components.code, {
            children: "storybook-static"
          }), " 添加到 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 构建任务的输出中："]
        }), _jsxs(_components.p, {
          children: ["¥To ensure file outputs are cached when you run ", _jsx(_components.code, {
            children: "build"
          }), ", add ", _jsx(_components.code, {
            children: "storybook-static"
          }), " to the outputs of your ", _jsx(_components.code, {
            children: "turbo.json"
          }), " build task:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"outputs\": ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        \".next/**\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        \"!.next/cache/**\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+       \"storybook-static/**\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(Step, {
          children: [_jsxs(_components.h3, {
            id: "将-storybook-构建输出添加到-gitignore-add-storybook-build-outputs-to-gitignore",
            children: ["将 Storybook 构建输出添加到 ", _jsx(_components.code, {
              children: ".gitignore"
            }), " "]
          }), _jsxs(_components.p, {
            children: ["¥Add Storybook build outputs to ", _jsx(_components.code, {
              children: ".gitignore"
            })]
          }), _jsx(_components.p, {
            children: "确保 Storybook 的构建输出未提交到源代码管理"
          }), _jsx(_components.p, {
            children: "¥Ensure that the build outputs for Storybook are not committed to source control"
          }), _jsx(_Fragment, {
            children: _jsx(_components.pre, {
              className: "shiki shiki-themes css-variables css-variables",
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)",
                "--shiki-light-bg": "var(--shiki-background)",
                "--shiki-dark-bg": "var(--shiki-background)"
              },
              tabIndex: "0",
              title: ".gitignore",
              icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
              children: _jsx(_components.code, {
                children: _jsx(_components.span, {
                  className: "line",
                  children: _jsx(_components.span, {
                    style: {
                      "--shiki-light": "var(--shiki-token-inserted)",
                      "--shiki-dark": "var(--shiki-token-inserted)"
                    },
                    children: "+ storybook-static"
                  })
                })
              })
            })
          })]
        }), _jsxs(Step, {
          children: [_jsx(_components.h3, {
            id: "验证配置-verify-your-configuration",
            children: "验证配置 "
          }), _jsx(_components.p, {
            children: "¥Verify your configuration"
          }), _jsxs(_components.p, {
            children: ["运行 ", _jsx(_components.code, {
              children: "turbo build"
            }), " 以构建 Storybook 应用以及其他应用。"]
          }), _jsxs(_components.p, {
            children: ["¥Run ", _jsx(_components.code, {
              children: "turbo build"
            }), " to build the Storybook application alongside the rest of your applications."]
          }), _jsxs(_components.p, {
            children: ["你还可以再次运行 ", _jsx(_components.code, {
              children: "turbo build"
            }), " 来查看构建的缓存命中情况。"]
          }), _jsxs(_components.p, {
            children: ["¥You can also run ", _jsx(_components.code, {
              children: "turbo build"
            }), " again to see cache hits for your builds."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "更多提示-more-tips",
      children: "更多提示 "
    }), "\n", _jsx(_components.p, {
      children: "¥More tips"
    }), "\n", _jsx(_components.h3, {
      id: "共置故事-co-locating-stories",
      children: "共置故事 "
    }), "\n", _jsx(_components.p, {
      children: "¥Co-locating stories"
    }), "\n", _jsx(_components.p, {
      children: "如果你希望将故事与其源代码放在一起（而不是将它们放在 Storybook 应用中），则需要进行一些额外的配置。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you'd prefer to co-locate your stories to their source code (rather than having them in the Storybook application), you'll need some extra configuration."
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "重新配置-storybook-源-re-configure-storybook-sources",
          children: "重新配置 Storybook 源 "
        }), _jsx(_components.p, {
          children: "¥Re-configure Storybook sources"
        }), _jsxs(_components.p, {
          children: ["在 ", _jsx(_components.code, {
            children: ".storybook/main.ts"
          }), " 中，将 ", _jsx(_components.code, {
            children: "config"
          }), " 中的 ", _jsx(_components.code, {
            children: "stories"
          }), " 路径更改为你想要捕获的目录。例如，如果你想在 UI 包中编写故事："]
        }), _jsxs(_components.p, {
          children: ["¥In ", _jsx(_components.code, {
            children: ".storybook/main.ts"
          }), ", change the ", _jsx(_components.code, {
            children: "stories"
          }), " paths in ", _jsx(_components.code, {
            children: "config"
          }), " to the directories you'd like to capture. For instance, if you'd like to write stories in the UI package:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/.storybook/main.ts",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "const config = {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  stories: ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-   \"../src/**/*.mdx\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-   \"../src/**/*.stories.@(js|jsx|mjs|ts|tsx)\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"../../../packages/ui/src/**/*.stories.@(js|jsx|mjs|ts|tsx)\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "将故事文件移动到-ui-包-move-story-files-to-the-ui-package",
          children: "将故事文件移动到 UI 包 "
        }), _jsx(_components.p, {
          children: "¥Move story files to the UI package"
        }), _jsxs(_components.p, {
          children: ["按照 ", _jsx(_components.a, {
            href: "/docs/guides/tools/storybook#set-up-a-story-for-your-button-component",
            children: "上一指南"
          }), " 的原则，将 ", _jsx(_components.code, {
            children: "./apps/storybook/src/stories/Button.stories.tsx"
          }), " 文件移动到 ", _jsx(_components.code, {
            children: "./packages/ui/src/Button.stories.tsx"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Following along with ", _jsx(_components.a, {
            href: "/docs/guides/tools/storybook#set-up-a-story-for-your-button-component",
            children: "the guide above"
          }), ", move the ", _jsx(_components.code, {
            children: "./apps/storybook/src/stories/Button.stories.tsx"
          }), " file to ", _jsx(_components.code, {
            children: "./packages/ui/src/Button.stories.tsx"
          }), "."]
        }), _jsx(_components.p, {
          children: "更新组件导入，使其引用现在位于同一位置的模块。例如，在故事的导入中："
        }), _jsx(_components.p, {
          children: "¥Update components imports so that they reference the now co-located modules. For instance, in the story's imports:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/src/Button.stories.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- import { Button } from \"@repo/ui/button\";"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ import { Button } from \"./button\";"
                })
              })]
            })
          })
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["你可能还需要根据你的更改和使用情况更新 ", _jsx(_components.a, {
              href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
              children: "绝对值导入"
            }), "。"]
          }), _jsxs(_components.p, {
            children: ["¥You may also need to update ", _jsx(_components.a, {
              href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
              children: "absolute\nimports"
            }), "\naccording to your changes and usage."]
          })]
        }), _jsxs(_components.p, {
          children: ["你还需要安装编写故事所需的所有 Storybook 包。例如，从上面移动故事需要你将 ", _jsx(_components.code, {
            children: "@storybook/react"
          }), " 安装到你的 ", _jsx(_components.code, {
            children: "@repo/ui"
          }), " 包中。"]
        }), _jsxs(_components.p, {
          children: ["¥You'll also need to install any Storybook packages required for writing stories. For example, moving the story from above would require that you install ", _jsx(_components.code, {
            children: "@storybook/react"
          }), " into your ", _jsx(_components.code, {
            children: "@repo/ui"
          }), " package."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " packages/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: " &&"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: " bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @storybook/react"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "配置缓存-configure-caching",
          children: "配置缓存 "
        }), _jsx(_components.p, {
          children: "¥Configure caching"
        }), _jsx(_components.p, {
          children: "由于故事现在位于 UI 包中，因此对这些故事的更改可能会导致任何依赖于 UI 包的构建发生缓存未命中。但是，更改故事并不意味着你的生产应用应该丢失缓存。"
        }), _jsx(_components.p, {
          children: "¥Because stories are now in the UI package, changes to those stories can cause cache misses for any builds that depend on your UI package. However, changing a story doesn't mean your production applications should miss cache."
        }), _jsxs(_components.p, {
          children: ["为防止这种情况，请在根 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中将故事从 ", _jsx(_components.code, {
            children: "build"
          }), " 任务的输入中排除。你还需要创建一个 ", _jsx(_components.code, {
            children: "build:storybook"
          }), " 任务，稍后你将需要它："]
        }), _jsxs(_components.p, {
          children: ["¥To prevent this, exclude stories from the inputs to your ", _jsx(_components.code, {
            children: "build"
          }), " task in your root ", _jsx(_components.code, {
            children: "turbo.json"
          }), ". You'll also need to create a ", _jsx(_components.code, {
            children: "build:storybook"
          }), " task, which you'll need in a moment:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!**/*.stories.{tsx,jsx,mdx}\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {} "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["此外，在 ", _jsx(_components.code, {
            children: "storybook"
          }), " 应用中创建一个 ", _jsx(_components.a, {
            href: "/docs/reference/package-configurations",
            children: "软件包配置"
          }), "，以便在构建 Storybook 应用时考虑故事，具体来说："]
        }), _jsxs(_components.p, {
          children: ["¥Additionally, create a ", _jsx(_components.a, {
            href: "/docs/reference/package-configurations",
            children: "Package Configuration"
          }), " in the ", _jsx(_components.code, {
            children: "storybook"
          }), " application so stories are ", _jsx(_components.strong, {
            children: "accounted for in building the Storybook application, specifically"
          }), ":"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/storybook/turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"extends\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"//\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"storybook-static/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(Callout, {
          type: "good-to-know",
          children: [_jsxs(_components.p, {
            children: ["如果你正在使用 ", _jsx(_components.a, {
              href: "/docs/core-concepts/internal-packages#compiled-packages",
              children: "编译包模式"
            }), "，则可能还需要将 ", _jsx(_components.code, {
              children: "^build"
            }), " 添加到你的 ", _jsx(_components.code, {
              children: "dependsOn"
            }), " 中。"]
          }), _jsxs(_components.p, {
            children: ["¥If you are using the ", _jsx(_components.a, {
              href: "/docs/core-concepts/internal-packages#compiled-packages",
              children: "Compiled Package\npattern"
            }), ", you may\nalso need to add ", _jsx(_components.code, {
              children: "^build"
            }), " to your ", _jsx(_components.code, {
              children: "dependsOn"
            }), "."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "重命名构建脚本-rename-the-build-script",
          children: "重命名构建脚本 "
        }), _jsx(_components.p, {
          children: "¥Rename the build script"
        }), _jsx(_components.p, {
          children: "最后，确保你用于构建 Storybook 的脚本使用我们刚刚编写的配置，方法是将其重命名为任务名称："
        }), _jsx(_components.p, {
          children: "¥Last, make sure your script to build Storybook uses the configuration we just wrote by renaming it to the name of the task:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "apps/storybook/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook dev -p 6006\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build:storybook\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"storybook build\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["曾经是 ", _jsx(_components.code, {
            children: "\"build\""
          }), " 的脚本现在变为 ", _jsx(_components.code, {
            children: "\"build:storybook\""
          }), "，以确保故事包含在哈希表中以便缓存。"]
        }), _jsxs(_components.p, {
          children: ["¥The script that was once ", _jsx(_components.code, {
            children: "\"build\""
          }), " is now ", _jsx(_components.code, {
            children: "\"build:storybook\""
          }), " to ensure the stories are included in hashes for caching."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "验证配置-verify-your-configuration-1",
          children: "验证配置 "
        }), _jsx(_components.p, {
          children: "¥Verify your configuration"
        }), _jsx(_components.p, {
          children: "为确保你的设置正确："
        }), _jsx(_components.p, {
          children: "¥To ensure your setup is correct:"
        }), _jsxs(_components.ol, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["运行 ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), "。你应该看到缓存未命中。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Run ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), ". You should see cache misses."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["再次运行 ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), "。你应该看到所有缓存命中。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Run ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), " again. You should see all cache hits."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["对你的 ", _jsx(_components.code, {
                children: "@repo/ui"
              }), " 软件包中的故事进行代码更改。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Make a code change ", _jsx(_components.strong, {
                children: "to a story"
              }), " in your ", _jsx(_components.code, {
                children: "@repo/ui"
              }), " package."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: ["再次运行 ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), "。你应该只会看到 Storybook 应用的缓存未命中。所有其他变量都应该命中缓存。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥Run ", _jsx(_components.code, {
                children: "turbo build:storybook build"
              }), " again. You should ", _jsx(_components.strong, {
                children: "only"
              }), " see a cache miss for the Storybook application. All others should hit cache."]
            }), "\n"]
          }), "\n"]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "添加-css-adding-css",
      children: "添加 CSS "
    }), "\n", _jsx(_components.p, {
      children: "¥Adding CSS"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你的 UI 包导出了其自身的 CSS，则需要将其添加到 Storybook 应用的渲染中，类似于将其添加到应用中的方式。", _jsx(_components.a, {
        href: "https://storybook.nodejs.cn/docs/configure/styling-and-css#css",
        children: "Storybook 文档"
      }), " 建议你将其添加到 ", _jsx(_components.code, {
        children: ".storybook/preview.ts"
      }), " 文件中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If your UI package exports its own CSS, you'll need to add it to the renders in the Storybook app, similar to how you would add it to your applications. ", _jsx(_components.a, {
        href: "https://storybook.nodejs.cn/docs/configure/styling-and-css#css",
        children: "The Storybook documentation"
      }), " recommends you add it to the ", _jsx(_components.code, {
        children: ".storybook/preview.ts"
      }), " file."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
